<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des contacts</h2>
    <p class="page-subtitle">Liste de tous vos contacts professionnels</p>
  </div>
  <a routerLink="/contacts/new" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouveau contact
  </a>
</div>

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange(searchQuery)"
          placeholder="Rechercher un contact..."
          class="search-input"
        >
      </div>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived()" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivés
        </label>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField">
      <thead>
      <tr>
        <th mat-sort-header="nom">Nom</th>
        <th mat-sort-header="prenom">Prénom</th>
        <th mat-sort-header="telephone">Téléphone</th>
        <th mat-sort-header="email">Email</th>
      </tr>
      </thead>
      <tbody>
        @for (contact of contacts(); track contact.id) {
          <tr (click)="onRowClick(contact)" class="clickable-row" [class.archived-row]="contact.archived">
            <td>
              {{ contact.nom }}
              @if (contact.archived) {
                <span class="badge-archived">Archivé</span>
              }
            </td>
            <td>{{ contact.prenom }}</td>
            <td>{{ contact.telephone }}</td>
            <td>{{ contact.email }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="4">
              <div class="empty-state">
                <mat-icon class="empty-icon" aria-hidden="true">inbox</mat-icon>
                <p>Aucun contact trouvé</p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>

@if (showDeleteModal()) {
  <app-confirm-dialog
    title="Supprimer le contact"
    [message]="'Êtes-vous sûr de vouloir supprimer le contact ' + contactToDelete()?.nom + ' ' + contactToDelete()?.prenom + ' ?'"
    (confirmed)="confirmDelete()"
    (cancelled)="cancelDelete()">
  </app-confirm-dialog>
}
